var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.774,
    height: 18.774,
    viewBox: "0 0 18.774 18.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layers",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(1.15 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M10.537,1.15a.655.655,0,0,1,.329.09l8.651,5a.914.914,0,0,1,0,1.521l-8.651,5a.647.647,0,0,1-.658,0l-8.651-5a.914.914,0,0,1,0-1.521l8.651-5A.655.655,0,0,1,10.537,1.15ZM17.544,7,10.537,2.95,3.53,7l7.007,4.05Z",
    transform: "translate(-1.15 -1.15)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M10.537,22.85a.655.655,0,0,1-.329-.09l-8.651-5a.916.916,0,0,1-.329-1.14.692.692,0,0,1,.987-.38l8.323,4.81,8.323-4.81a.692.692,0,0,1,.987.38.916.916,0,0,1-.329,1.14l-8.651,5A.655.655,0,0,1,10.537,22.85Z",
    transform: "translate(-1.15 -4.076)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M10.537,17.85a.655.655,0,0,1-.329-.09l-8.651-5a.916.916,0,0,1-.329-1.14.692.692,0,0,1,.987-.38l8.323,4.81,8.323-4.81a.692.692,0,0,1,.987.38.916.916,0,0,1-.329,1.14l-8.651,5A.655.655,0,0,1,10.537,17.85Z",
    transform: "translate(-1.15 -3.101)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers2);
export default __webpack_public_path__ + "static/media/layers2.ce7a359f8352b076f54a452a2c97fca0.svg";
export { ForwardRef as ReactComponent };